import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, Ticket } from "lucide-react";

export default function PaymentSuccess() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [bookingRef, setBookingRef] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setBookingRef(data.booking_ref);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status) || attempts.current > 8) { setStatus("failed"); return; }
      } catch {
        if (attempts.current > 8) { setStatus("failed"); return; }
      }
      attempts.current += 1;
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        {status === "checking" && (<><Loader2 size={56} className="animate-spin text-tigris mx-auto mb-5" /><p className="text-slate-600 font-medium">{t.payment.verifying}</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 size={64} className="text-green-500 mx-auto mb-5" />
          <h1 className="text-2xl font-bold text-slate-800 mb-2">{t.payment.success}</h1>
          <p className="text-slate-500 mb-7">{t.voucher.emailSent}</p>
          <button data-testid="go-voucher" onClick={() => nav(`/booking/${bookingRef}`)} className="btn-gold w-full py-3.5 rounded-xl font-bold flex items-center justify-center gap-2">
            <Ticket size={18} /> {t.payment.goVoucher}
          </button>
        </>)}
        {status === "failed" && (<>
          <XCircle size={64} className="text-red-500 mx-auto mb-5" />
          <h1 className="text-2xl font-bold text-slate-800 mb-2">{t.payment.failed}</h1>
          <Link to="/" className="btn-primary inline-flex mt-4 px-6 py-3 rounded-xl font-bold">{t.brand}</Link>
        </>)}
      </div>
    </div>
  );
}
